import {useContainerBreakpoint} from "@project/layouts";
import {routes} from "@project/router";
import {Navigate, createFileRoute, useParams} from "@tanstack/react-router";
import {useRef} from "react";

import {Route as SupplierRoute} from "./route";

export const Route = createFileRoute("/_app/engineering/suppliers/$supplierId/")({
  component: IndexRouteComponent,
});

function IndexRouteComponent() {
  const {supplierId} = useParams({strict: false}) as {supplierId: string};
  const {includeDeleted} = SupplierRoute.useSearch();
  const ref = useRef<HTMLDivElement>(null);
  const isDesktop = useContainerBreakpoint(ref);

  if (isDesktop) {
    return (
      <Navigate
        replace
        params={{supplierId}}
        search={{
          page: 1,
          perPage: 10,
          state: "ACTIVE",
          sortKey: "catalogItemId",
          sortDir: "asc",
          includeDeleted,
        }}
        to={routes.engineering.suppliers.supplier().offers()}
      />
    );
  }

  return <div ref={ref} className="h-full w-full" />;
}
